import React from 'react';
import { FilterForm, useFilterFormActions } from './filter-form';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';

export const BooleanFilters = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItems} />
);


export const BooleanFilterReputation = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormReputation} />
);

export const BooleanFilters2 = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItems2} />
);

export const BooleanFilters3 = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItems3} />
);


function BooleanFilterFormReputation({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );

  return (
    <>
      <FormControlLabel
        value="false"
        control={<Radio />}
        label="Has Override Score"
        name="$empty"
        inputRef={form.register}
      />
      <FormControlLabel
        value="true"
        control={<Radio />}
        label="No Override Score"
        name="$empty"
        inputRef={form.register}
      />
    </>
  );
}

function BooleanFilterFormItems({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );

  return (
    <>
      <FormControlLabel
        value="false"
        control={<Radio />}
        label="Available"
        name="$empty"
        inputRef={form.register}
      />
      <FormControlLabel
        value="true"
        control={<Radio />}
        label="Not Available"
        name="$empty"
        inputRef={form.register}
      />
    </>
  );
}

function BooleanFilterFormItems2({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );

  return (
    <>
      <FormControlLabel
        value="Yes"
        control={<Radio />}
        label="Yes"
        name="$eq"
        inputRef={form.register}
      />
      <FormControlLabel
        value="No"
        control={<Radio />}
        label="No"
        name="$eq"
        inputRef={form.register}
      />
      <FormControlLabel
        value="Not_available"
        control={<Radio />}
        label="Not Available"
        name="$eq"
        inputRef={form.register}
      />
    </>
  );
}

function BooleanFilterFormItems3({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );

  return (
    <>
      <FormControlLabel
        value="Yes"
        control={<Radio />}
        label="Yes"
        name="$eq"
        inputRef={form.register}
      />
      <FormControlLabel
        value="No"
        control={<Radio />}
        label="No"
        name="$eq"
        inputRef={form.register}
      />
    </>
  );
}
